import { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useAuth } from './AuthContext';

// Internal domain used to convert "username" -> email for Supabase auth
const USERNAME_DOMAIN = '@wcmc.local';

export default function LoginModal({ onClose }) {
  const { signIn, user, signOut, isAdmin } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    const email = username.trim().toLowerCase() + USERNAME_DOMAIN;
    const { error } = await signIn(email, password);
    setSubmitting(false);
    if (error) setError('Invalid username or password');
    else onClose();
  }

  // If already signed in, show signed-in panel
  if (user) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-panel" onClick={e => e.stopPropagation()}>
          <button className="modal-close" onClick={onClose}><FaTimes /></button>
          <h2>Signed In</h2>
          <p className="modal-sub">Signed in as <strong>{user.email.replace(USERNAME_DOMAIN, '')}</strong></p>
          <div className="modal-signedin-body">
            {isAdmin
              ? <span className="modal-badge modal-badge-admin">Admin access</span>
              : <span className="modal-badge">Standard access</span>}
            <button className="cta-button cta-small" onClick={async () => { await signOut(); onClose(); }}>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-panel" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}><FaTimes /></button>
        <h2>Admin Sign In</h2>
        <p className="modal-sub">Staff only — for editing site content.</p>
        <form onSubmit={handleSubmit} className="modal-form">
          <label>
            Username
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
              autoFocus
              autoComplete="username"
            />
          </label>
          <label>
            Password
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </label>
          {error && <p className="modal-error">{error}</p>}
          <button type="submit" className="cta-button" disabled={submitting}>
            {submitting ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
